import SupportAgentIcon from '@mui/icons-material/SupportAgent'
import { StepRegistarEnum } from '@/types/enum/register'

export const routeFrontOfficeCommonUser = [
  {
    route: 'MyProfile',
    text: 'Mon profil',
    t: 'routes.frontoffice.storeBag.myProfile',
    href: '/frontoffice/group/my-profile',
    menuHeader: false,
  },
  {
    // Nom UNIQUE (plusieurs routes s'appellent deja MyProfile, dont une backoffice via
    // routeFrontOfficeSchoolRankingCommonUser -> resolution ambigue) : cible deterministe
    // de l'etape segmentation du parcours guide (JourneyCard).
    route: 'MyPharmacyProfileSegmentation',
    text: 'Mon profil — segmentation',
    t: 'routes.frontoffice.storeBag.myProfile',
    // `?step=` OUVRE le questionnaire de segmentation. Il s'imposait auparavant a toute
    // ouverture de « Mon profil » quand la segmentation etait vide : on y arrive desormais
    // par cette cible explicite (etape du parcours guide), jamais par surprise.
    href: `/frontoffice/group/my-profile?step=${StepRegistarEnum.Step3}`,
    menuHeader: false,
  },
  {
    route: 'SupportTickets',
    text: 'Mes tickets',
    t: 'routes.frontoffice.group.tickets',
    icon: SupportAgentIcon,
    href: '/frontoffice/group/tickets',
    menuHeader: true,
    // Menu v2 : entree de NIVEAU 1, EN BAS du menu — un ticket suit l'UTILISATEUR (son
    // historique de support), pas un module. Etait range dans « Ma pharmacie ».
    menuFlat: 'bottom' as const,
    position: 910,
  },
  {
    route: 'SupportTicketDetail',
    text: 'Detail ticket',
    t: 'routes.frontoffice.group.ticketDetail',
    href: '/frontoffice/group/tickets/[ticketId]',
  },
]
